import { render, staticRenderFns } from "./model-registerFoot.vue?vue&type=template&id=77eaf3ac&scoped=true&"
import script from "./model-registerFoot.vue?vue&type=script&lang=js&"
export * from "./model-registerFoot.vue?vue&type=script&lang=js&"
import style0 from "./model-registerFoot.vue?vue&type=style&index=0&id=77eaf3ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77eaf3ac",
  null
  
)

export default component.exports